var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreece({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_6436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_6436",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_6436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 21.2514H3V23.5857H39V21.2514Z",
    fill: "#2A2874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 18.917H3V21.2514H39V18.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 16.5826H3V18.917H39V16.5826Z",
    fill: "#2A2874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 14.2483H3V16.5826H39V14.2483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 11.9138H3V14.2482H39V11.9138Z",
    fill: "#2A2874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 9.5795H3V11.9139H39V9.5795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 7.24512H3V9.57949H39V7.24512Z",
    fill: "#2A2874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 4.91077H3V7.24514H39V4.91077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 2.5834H3V4.91778H39V2.5834Z",
    fill: "#2A2874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6648 2.5834H3V14.2482H14.6648V2.5834Z",
    fill: "#2A2874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6648 7.24512H3V9.57949H14.6648V7.24512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0031 2.5834H7.66872V14.2482H10.0031V2.5834Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_6436",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_6436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_6436",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/Greece.407a34b87e3bd22e3fa24eb25444f50f.svg";
export { ForwardRef as ReactComponent };